import { QuizIdsEnum } from 'components/PageSections/AsyncProgramPPQ/constants';

import { ASYNC_PROGRAMS_QUIZ_IDS } from '../../../constants';
import {
  BIRTH_ASSIGNED_SEX_OBJ,
  PrePurchaseQuizPersonalData,
} from '../PersonalDataForm';

const ineligibleProgramsForMale = [
  ASYNC_PROGRAMS_QUIZ_IDS['bv-async'],
  ASYNC_PROGRAMS_QUIZ_IDS['uti-async'],
  ASYNC_PROGRAMS_QUIZ_IDS['yeast-infection-async'],
];

const ineligibleProgramsForAgeBVandYI = [
  ASYNC_PROGRAMS_QUIZ_IDS['bv-async'],
  ASYNC_PROGRAMS_QUIZ_IDS['yeast-infection-async'],
];

const ineligibleProgramsForAgeGHandCS = [
  ASYNC_PROGRAMS_QUIZ_IDS['genital-herpes-async'],
  ASYNC_PROGRAMS_QUIZ_IDS['cold-sores-async'],
];

// Bacterial Vaginosis And Yeast Infection
export function validateBvAndYiConditions(age: number, quizId: QuizIdsEnum) {
  return (
    ineligibleProgramsForAgeBVandYI.includes(quizId) && (18 > age || age >= 50)
  );
}

export function validateUtiConditions(age: number, quizId: QuizIdsEnum) {
  return quizId === ASYNC_PROGRAMS_QUIZ_IDS['uti-async'] && 18 > age;
}

// Genital Herpes And Cold Sores
export function validateGhAndCsConditions(age: number, quizId: QuizIdsEnum) {
  return (
    ineligibleProgramsForAgeGHandCS.includes(quizId) && (18 > age || age >= 65)
  );
}

export function validateProgramSexIneligible(sex: string, quizId: QuizIdsEnum) {
  return (
    ineligibleProgramsForMale.includes(quizId) &&
    sex === BIRTH_ASSIGNED_SEX_OBJ.male.id
  );
}

export const isPersonalDataIneligible = (
  formData: PrePurchaseQuizPersonalData,
  quizId: QuizIdsEnum,
) => {
  const { personalData } = formData;

  let ineligible = false;

  if (
    validateBvAndYiConditions(personalData.age, quizId) ||
    validateUtiConditions(personalData.age, quizId) ||
    validateGhAndCsConditions(personalData.age, quizId) ||
    validateProgramSexIneligible(personalData.sex, quizId)
  ) {
    ineligible = true;
  }

  return ineligible;
};
